import React from 'react'
import { Edit } from 'react-admin'
import { connect } from 'react-redux'

import InputList from '../inputs/InputList'
import CustomTitle from '../Title/Title'
import extendGlobalEntity from 'src/parser/entities/extendGlobalEntity'
import { transform } from '../utils/transform'

export const CustomEdit = ({ entity, name, ...props }) => {
  const { id, basePath, resource } = props
  const editEntity = extendGlobalEntity(entity, 'edit')
  const {
    displayedComponent: DisplayedComponent,
    properties,
    redirect = 'list',
  } = editEntity

  if (DisplayedComponent != null) {
    return (
      <DisplayedComponent
        entity={editEntity}
        name={name}
        id={id}
        basePath={basePath}
        resource={resource}
        {...props}
      />
    )
  }

  return (
    <Edit
      transform={transform(properties)}
      title={
        <CustomTitle
          entity={editEntity}
          {...props}
        />
      }
      basePath={basePath}
      resource={resource}
      redirect={redirect}
      id={id}
      key={id}
    >
      <InputList
        entity={editEntity}
        {...props}
      />
    </Edit>
  )
}

const mapStateToProps = state => {
  return {
    entities: state.definitions.entities || {},
    microservices: state.microservices,
  }
}

export default connect(mapStateToProps, null)(CustomEdit)
